import {
	APP_INITIALIZER,
	CUSTOM_ELEMENTS_SCHEMA,
	NgModule,
	PLATFORM_ID
} from '@angular/core';

import {
	BrowserModule
} from '@angular/platform-browser';

import {
	isPlatformBrowser,
	registerLocaleData
} from '@angular/common';

import {
	HttpClientModule
} from '@angular/common/http';

import localeFr from '@angular/common/locales/fr';

import {
	BrowserAnimationsModule
} from '@angular/platform-browser/animations';

import {
	RouterModule
} from '@angular/router';

import {
	AppRoutingModule
} from './app-routing.module';

import {
	CoreModule
} from './modules/core/core.module';

import {
	AppComponent
} from './app.component';

import {
	AppConfig,
	APP_CONFIG
} from './configs/app.config';

import {
	SharedModule
} from './shared/shared.module';

import {
	RoutesConfig,
	ROUTES_CONFIG
} from './configs/routes.config';

import {
	EndpointsConfig,
	ENDPOINTS_CONFIG
} from './configs/endpoints.config';

import {
	CookiesConfig,
	COOKIES_CONFIG
} from './configs/cookies.config';

import {
	LandingPageAvvcComponent
} from './features/landing-page-avvc/landing-page-avvc.component';

import {
	RuntimeConfigLoaderModule,
	RuntimeConfigLoaderService,
	initConfig
} from 'runtime-config-loader';

export function appInitializer(platformId: object) {
	return (): void => {
		if (isPlatformBrowser(platformId)) {
			registerLocaleData(localeFr, 'fr');
		}
	};
}

const modulesDeclarations = [
	AppComponent,
	LandingPageAvvcComponent
];

const importModules = [
	BrowserModule,
	HttpClientModule,
	RouterModule,
	AppRoutingModule,
	BrowserAnimationsModule,
	CoreModule,
	SharedModule,
	RuntimeConfigLoaderModule.forRoot({ configUrl: './assets/config/config.json' }),
];

@NgModule({
	declarations: [...modulesDeclarations],
	imports: [...importModules],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: appInitializer,
			deps: [PLATFORM_ID],
			multi: true
		}, {
			provide: APP_INITIALIZER,
			useFactory: initConfig,
			deps: [RuntimeConfigLoaderService],
			multi: true
		}, {
			provide: APP_CONFIG,
			useValue: AppConfig
		}, {
			provide: ROUTES_CONFIG,
			useValue: RoutesConfig
		}, {
			provide: ENDPOINTS_CONFIG,
			useValue: EndpointsConfig
		},  {
			provide: COOKIES_CONFIG,
			useValue: CookiesConfig
		}],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	],
	bootstrap: [
		AppComponent
	]
})

export class AppModule {}
